import { StackChildren, StackChildrenSize, InlineChildren, InlineChildrenAlignment, InlineChildrenJustification, InlineChildrenSize, Text, TextStyle, TextColor } from '@doordash/design-language';
import ErrorMessage from './ErrorMessage.js';
import './styles/Input.js';
import './styles/Time.js';
import './styles/Select.js';
import { FieldRoot } from './styles/Field.js';
import './styles/Password.js';
import InputWrapper from './InputWrapper.js';
import React__default from 'react';
import { FieldSize, FieldSizeSemantic } from '../constants.js';
import { withUniqueId } from '@doordash/utilities';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var PREFIX_ID = 'FieldWrapper';

var FieldWrapper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FieldWrapper, _React$PureComponent);

  var _super = _createSuper(FieldWrapper);

  function FieldWrapper() {
    var _this;

    _classCallCheck(this, FieldWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          inputRef = _this$props.inputRef; // TODO: Technically we no longer need this, but keeping it to avoid unknown side-effects,
      // but we should remove this when we refactor this to a functional component

      if (inputRef && inputRef.current && inputRef.current.focus) {
        inputRef.current.focus();
      }

      if (onClick) {
        onClick(e);
      }
    });

    return _this;
  }

  _createClass(FieldWrapper, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$isLabelH = _this$props2.isLabelHidden,
          isLabelHidden = _this$props2$isLabelH === void 0 ? false : _this$props2$isLabelH,
          _this$props2$size = _this$props2.size,
          size = _this$props2$size === void 0 ? FieldSize.Medium : _this$props2$size,
          _this$props2$__focusB = _this$props2.__focusBehavior,
          __focusBehavior = _this$props2$__focusB === void 0 ? 'default' : _this$props2$__focusB,
          isDisabled = _this$props2.isDisabled,
          label = _this$props2.label,
          id = _this$props2.id,
          uniqueId = _this$props2.uniqueId,
          error = _this$props2.error,
          errorElementId = _this$props2.errorElementId,
          description = _this$props2.description,
          hint = _this$props2.hint,
          accessibilityDescribedBy = _this$props2.accessibilityDescribedBy,
          hasConnectedContentAbove = _this$props2.hasConnectedContentAbove,
          hasConnectedContentBelow = _this$props2.hasConnectedContentBelow,
          renderBeforeContent = _this$props2.renderBeforeContent,
          renderAfterContent = _this$props2.renderAfterContent,
          renderConnectedBefore = _this$props2.renderConnectedBefore,
          renderConnectedAfter = _this$props2.renderConnectedAfter,
          children = _this$props2.children,
          isBare = _this$props2.isBare,
          isRounded = _this$props2.isRounded,
          isAdjustableHeight = _this$props2.isAdjustableHeight,
          hasDefaultRenderContent = _this$props2.hasDefaultRenderContent,
          inputRef = _this$props2.inputRef; // In some cases, users want to provide their own `id` to our Field components.
      // This prioritizes the `id` prop over our custom generated ID when it's provided to the component, while
      // falling back to one we generate to ensure the label and field components are always connected
      // via `id` values for accessibility purposes.


      var idToUse = !!id ? id : uniqueId; // Figure out the correct thing to pass
      // to the field based on what is provided
      // errors trump explicit accessibilityDescribedBy,
      // which trump descriptions; accessibilityDescribedBy
      // will often be used to have an external description
      // (like a tooltip) and description is the internal
      // description

      var describedBy = undefined;

      if (error && typeof error === 'string') {
        describedBy = "".concat(idToUse, "-error");
      } else if (error && errorElementId) {
        describedBy = errorElementId;
      } else if (typeof accessibilityDescribedBy !== 'undefined') {
        describedBy = accessibilityDescribedBy;
      } else if (description) {
        describedBy = "".concat(idToUse, "-description");
      }

      return /*#__PURE__*/React__default.createElement(FieldRoot, {
        onClick: this.handleClick
      }, /*#__PURE__*/React__default.createElement(StackChildren, {
        size: StackChildrenSize.XxSmall
      }, label && !isLabelHidden && /*#__PURE__*/React__default.createElement(InlineChildren, {
        alignItems: InlineChildrenAlignment.FlexEnd,
        justifyContent: InlineChildrenJustification.SpaceBetween,
        size: InlineChildrenSize.Medium
      }, /*#__PURE__*/React__default.createElement(Text, {
        htmlFor: idToUse,
        styles: TextStyle["".concat(FieldSizeSemantic[size], "Label")],
        tag: "label",
        color: isDisabled ? TextColor.TextDisabled : TextColor.TextPrimary
      }, label), description && /*#__PURE__*/React__default.createElement(Text, {
        id: "".concat(idToUse, "-description"),
        styles: TextStyle["".concat(FieldSizeSemantic[size], "Description")],
        color: isDisabled ? TextColor.TextDisabled : TextColor.TextSecondary // Our cypress-axe contrast-color check is flagging this as an error for disabled states, when it should be allowed as
        // it's part of the disabled control (the aria-describedby connection is apparently not enough for axe to ignore the contrast).
        // While this is technically not a valid `span` attribute, including it should not hurt anything,
        // and it seems like the best way to silence those errors for the time being.
        // Because it's technically not valid, we return undefined when enabled so the attribute is only present when disabled.
        ,
        "aria-disabled": isDisabled ? true : undefined
      }, description)), /*#__PURE__*/React__default.createElement(InputWrapper, {
        isDisabled: isDisabled,
        error: error,
        renderBeforeContent: renderBeforeContent,
        renderAfterContent: renderAfterContent,
        renderConnectedBefore: renderConnectedBefore,
        renderConnectedAfter: renderConnectedAfter,
        hasConnectedContentAbove: hasConnectedContentAbove,
        hasConnectedContentBelow: hasConnectedContentBelow,
        isBare: isBare,
        size: size,
        isRounded: isRounded,
        isAdjustableHeight: isAdjustableHeight,
        hasDefaultRenderContent: hasDefaultRenderContent,
        __focusBehavior: __focusBehavior
      }, /*#__PURE__*/React__default.cloneElement(React__default.Children.only(children), {
        id: idToUse,
        'aria-describedby': describedBy,
        'aria-invalid': typeof error === 'boolean' && error === true ? true : undefined,
        ref: inputRef
      })), error && typeof error == 'string' && error.length && /*#__PURE__*/React__default.createElement(ErrorMessage, {
        id: "".concat(idToUse, "-error"),
        error: error,
        size: size
      }), hint && /*#__PURE__*/React__default.createElement(Text, {
        id: "".concat(idToUse, "-hint"),
        styles: TextStyle["".concat(FieldSizeSemantic[size], "Hint")],
        color: isDisabled ? TextColor.TextDisabled : TextColor.TextTertiary // Our cypress-axe contrast-color check is flagging this as an error for disabled states, when it should be allowed as
        // it's part of the disabled control (the aria-describedby connection is apparently not enough for axe to ignore the contrast).
        // While this is technically not a valid `span` attribute, including it should not hurt anything,
        // and it seems like the best way to silence those errors for the time being.
        // Because it's technically not valid, we return undefined when enabled so the attribute is only present when disabled.
        ,
        "aria-disabled": isDisabled ? true : undefined
      }, hint)));
    }
  }]);

  return FieldWrapper;
}(React__default.PureComponent);

var WrappedFieldWrapper = withUniqueId(FieldWrapper, {
  prefix: PREFIX_ID
});
WrappedFieldWrapper.Sizes = FieldSize;
WrappedFieldWrapper.defaultProps = {
  isLabelHidden: false,
  size: FieldSize.Medium,
  __focusBehavior: 'default'
};

export { WrappedFieldWrapper as default };
